module.exports = __webpack_public_path__ + "static/media/SFProText-Regular.0116e27f.woff";